<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/sY0BVI/media/FC-9781398426382.jpg?1684514527452" alt="This image is the cover for the book Apok"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Apok
      </h1>
      <p class="bookDescription body article font2">
        <p>Set in 1991 against the prelude to war in Croatia, Apok is a dystopian view of an imperfect world on the brink, as seen through the eyes of the equally imperfect hero sent to save it. For he is the ultimate psychopath, a formidable, soon-to-be-invincible, death machine, an anomaly which science thought impossible yet which religion had always prophesied. Who said the next messiah would be from heaven and that the second coming hasn’t already happened? And what if the battle for humankind’s survival is just about to begin? Apok is a thought-provoking horror-fantasy, an exhilarating tour de force of forbidden taboos and crippling addiction. It is the stuff of nightmares, a roller coaster ride through the darkest recesses of the human psyche, where demons and monsters from twilight dimensions rip your dreams apart. It takes you through the pain barrier to places none of us want to go but are still curious to explore despite the terror. Apok is about humanity’s failings and how our species is heading for oblivion; it is about one man’s incredible journey and his audacious plan to put things right. As the plan unfolds, Apok travels through the horrors of a damaged mind and how humankind must first suffer in order to survive. The plan to spread the madness that drives men to do evil things; his mission to wage war on everyone and everything. For his mantra is ‘take no prisoners, dispense death to all and spare no one!’ Apok is the dawn of Hell on Earth ...</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Adrian Lee Baker
      </h2>
      
      <p class="authorDescription body article">Adrian Lee Baker lives in a small village outside Ashby-de-la-Zouch, Leicestershire. He is fifty-three years old, married to Angela and has two daughters, Phoebe and Milly. His occupation is in teaching and works as a lecturer and trainer-assessor in further education. He likes country walking, mountain biking and is a Second Dan in the combat sport of kick-boxing. It has always been his ambition to write and have something published. He is an avid fan of both books and films, especially of the sci-fi and horror genres, and latterly, dark fantasy. Hence his writing style reflects the darker side of life. Favourite books include Nineteen Eighty-Four, A Clockwork Orange, Heart of Darkness, Dracula, Naked Lunch, and Fear and Loathing in Las Vegas.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1ba3c340